export default "__VITE_ASSET__BYq8gi8J__"